module.exports = __webpack_public_path__ + "static/media/oven.9eae4aab.svg";